export interface PersonName {
  forename?: string | null;
  surname?: string | null;
}

export function personDisplayName(person: PersonName): string {
  return [person.forename, person.surname]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' ');
}

export function personInitials(person: PersonName): string {
  return [person.forename, person.surname]
    .map((part) => part?.trim()[0] ?? '')
    .join('')
    .toUpperCase();
}

export function nameInitials(name: string, limit = 2): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, limit)
    .map((word) => word[0])
    .join('')
    .toUpperCase();
}
